export const breadcrumb = {
  title: 'Referensi program',
  user: {
    index: 'Referrals saya'
  },

  profit: {
    index: 'Data historis akumulasi '
  },

  request: {
    index: 'Aplikasi penarikan'
  }
};
